/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum GlobalFiltersDefaults {
    OrganizationDefaultId = -1,
    LocationDefaultId = -1,
}
